<template>
  <div>
    <banner-top/>
    <div class="content" :class="{'mt-10' : !$mq.isDesktop()}">
      <section>
        <div>
          <h2
            class="center mb-5 main-title"
            v-html="$t('components.plans.title')"
          />
          <p
              class="center"
              v-html="$t('components.plans.subtitle')"
          />
        </div>
      </section>
    </div>
    <section>
      <div class="plans-options">
        <div class="flex flex-column align-items-center">
          <div class="shadow-box mt-0 mb-3">
            <h2>Box coppia</h2>
            <p>Ideale per:</p>
            <p><i class="fas fa-check pr-2"/> 2 adulti</p>
            <p><i class="fas fa-check pr-2"/> 1 adulto e 1-2 bambini</p>
            <CTA
              :content="`Scegli le ricette`"
              style="margin-bottom: 0"
              @click="goAhead(2)"
            />
          </div>
          <span class="text-bold">A partire da 4,45€ a porzione!</span>
        </div>
        <div class="flex flex-column align-items-center">
          <div class="shadow-box mb-3">
            <h2>Box famiglia</h2>
            <p>Ideale per:</p>
            <p><i class="fas fa-check pr-2"/> 4 adulti</p>
            <p><i class="fas fa-check pr-2"/> 2 adulti e 2-3 bambini</p>
            <CTA
              :content="`Scegli le ricette`"
              style="margin-bottom: 0"
              @click="goAhead(4)"
            />
          </div>
          <span class="text-bold">A partire da 4,45€ a porzione!</span>
        </div>
      </div>
    </section>

    <section class="my-15 px-1">
        <div>
          <h2
            class="center uppercase"
            v-html="'Consegna gratuita sempre disponibile'"
            style="color: var(--quomi-primary)"
          />
          <p
              class="center uppercase text-bold"
              v-html="'Senza vincoli, sospendi o cancelli quando vuoi'"
          />
        </div>
    </section>

    <section class="flex flex-column align-items-center my-15 mx-5">
      <h2
      class="center"
        v-html="'Cucinare non è mai stato così facile...'"
      />

      <v-list dense disabled>
        <v-list-item-group>
          <v-list-item
            v-for="(item, i) in cooking"
            :key="i"
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon"></v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-html="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </section>

    <section class="my-15">
      <h3
        class="center uppercase text-bold"
        v-html="'Ricette per tutti i gusti'"
      />

      <div class="recipes-icons flex justify-content-around mt-10">
        <div
          v-for="(item, i) in recipes"
          :key="i"
        >
        <img :src="item.src" :alt="item.title" loading="lazy">
        <p>{{item.title}}</p>
        </div>
      </div>
    </section>

     <div class="flex flex-column align-items-center bg-soft-green py-5">
          <faq v-if="!onlyKitPricing"/>
              
          <center v-if="!onlyKitPricing">
            <CTA
                :content="`Torna su`"
                isArrowUp
                @click="scroll()"
              />
          </center>
        </div>
  </div>
</template>

<script>
import CTA from './Elements/CTA'
import Faq from './Faq'
import { container } from '../services/container'
import { scrollToTop } from '../assets/js/main.js'
import BannerTop from './Parts/BannerTop'

export default {
  components: {
    Faq,
    CTA,
    BannerTop
  },
  props: {
    full: {
      type: Boolean,
      default: true
    },
    onlyKitPricing: {
      type: Boolean
    },
    withoutTable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cooking: [
        { text: '<b>Più ricette ordini</b> più risparmi', icon: 'fa-solid fa-euro-sign' },
        { text: '<b>Tante nuove ricette</b> ogni settimana', icon: 'fa-solid fa-utensils' },
        { text: '<b>Scegli il numero di porzioni</b> e ricevi tutto nelle giuste dosi', icon: 'fa-solid fa-forward' },
        { text: '<b>Menù per tutti i gusti</b>', icon: 'fa-solid fa-leaf' },
      ],
      recipes: [
        { title: 'Carne e Pesce', src: 'https://api.quomi.it/oldimg/protein-%283%29.png' },
        { title: 'Vegetariano', src: 'https://api.quomi.it/oldimg/healthy-food-%282%29.png' },
        { title: 'Gourmet', src: 'https://api.quomi.it/oldimg/meal-%281%29.png' },
        { title: 'Famiglia', src: 'https://api.quomi.it/oldimg/pizza.png' },
      ]
    }
  },
  methods: {
		goAhead (people) {
      var cookies = container.get('services.cookies')

      cookies.set('people', people)

			this.$router.push({ name: 'flow-subscribed' })
	  },
    
    scroll () {
      scrollToTop()
    },
  }
}
</script>

<style scoped>
.plans-options {
  width: 70%;
  display: flex;
  justify-content: space-evenly;
  margin: 0 auto;
}

.shadow-box {
  padding: 15px 60px;
}

.recipes-icons  {
  width: 60%;
  margin: 0 auto;
  text-align: center;
}

.fa-check {
  color: var(--quomi-primary);
}
@media (max-width: 468px) {
  .plans-options {
    width: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
  }
  .shadow-box {
    padding: 15px 20px;
    margin: 15px;
  }

  .recipes-icons {
    width: 250px;
    flex-wrap: wrap;
  }

  .main-title {
    font-size: 29px;
  }
}

@media (max-width: 1025px) {
  .plans-options {
  width: 100%;
}
}
</style>